<ra-modal [title]="('document.edit.createFavoriteField.title' | translate)" (close)="close.emit()">

    <p>{{ 'document.edit.createFavoriteField.intro' | translate }}</p>

    <ra-input 
        [formControl]="favoriteFieldDescription"
        [label]="('document.edit.createFavoriteField.descriptionLabel' | translate)" 
        [placeholder]="('document.edit.createFavoriteField.descriptionPlaceholder' | translate)" 
    />

    <ra-button 
        class="button-save"
        [label]="'common.save' | translate" 
        [loading]="loading()"
        (click)="createFavoriteField()"
    />
</ra-modal>
